import { render, staticRenderFns } from "./USC_BAN10_AT03_R2.vue?vue&type=template&id=60a46ea0"
import script from "./USC_BAN10_AT03_R2.vue?vue&type=script&lang=js"
export * from "./USC_BAN10_AT03_R2.vue?vue&type=script&lang=js"
import style0 from "./USC_BAN10_AT03_R2.vue?vue&type=style&index=0&id=60a46ea0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports